export default __webpack_public_path__ + "6f1aa53c3144b5e5529aba0050874757.jpg";